<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span>Редактирование подробностей</span>
    </div>
    <v-form ref="formFirst" v-if="!isLoading">
      <div class="container-block">
        <div class="container-block-title">Информация о выборах</div>
        <div>
          <v-text-field
            label="Заголовок"
            type="text"
            outlined
            :rules="rules"
            v-model="detailsBlock.title"
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            label="Подзаголовок"
            type="text"
            outlined
            :rules="rules"
            v-model="detailsBlock.subtitle"
          ></v-text-field>
        </div>
        <div>
          <v-textarea
            label="Текст блока"
            type="text"
            outlined
            rows="1"
            auto-grow
            :rules="rules"
            v-model="detailsBlock.text"
          ></v-textarea>
        </div>
      </div>

      <div class="container-block">
        <ImageCropper
          @imageDesktopBlob="
            (img) => {
              mainPhoto.desktop = img;
            }
          "
          @imageMobileBlob="
            (img) => {
              mainPhoto.mobile = img;
            }
          "
          @imageTabletBlob="
            (img) => {
              mainPhoto.tablet = img;
            }
          "
          :inputPlaceholderText="'Прикрепить изображение главного фото'"
          :imgSrcProp="detailsBlock.image"
          :imgSrcMobileProp="detailsBlock.imageMobile"
          :imgSrcTabletProp="detailsBlock.imageTablet"
          :modelValue="newImage"
        ></ImageCropper>
        <ImageCropper
          @imageDesktopBlob="
            (img) => {
              coverPhoto.desktop = img;
            }
          "
          @imageMobileBlob="
            (img) => {
              coverPhoto.mobile = img;
            }
          "
          @imageTabletBlob="
            (img) => {
              coverPhoto.tablet = img;
            }
          "
          :inputPlaceholderText="'Прикрепить изображение для обложки'"
          hideTitle
          hideTitleHint
          :imgSrcProp="detailsBlock.cover"
          :imgSrcMobileProp="detailsBlock.coverMobile"
          :imgSrcTabletProp="detailsBlock.coverTablet"
          :modelValue="newImage"
          :placeToDisplay="'Изображение на фоне раздела'"
          :format="'Обложка'"
        ></ImageCropper>
      </div>

      <div class="container-block">
        <div class="container-block-title">Добавление ссылки</div>

        <div>
          <v-text-field
            label="Ссылка"
            type="text"
            outlined
            :rules="[checkValidUrl]"
            v-model="detailsBlock.url"
          ></v-text-field>
        </div>
        <div>
          <v-checkbox
            v-model="detailsBlock.isWebView"
            label="Открыть WebView (ссылка откроется внутри приложения)"
          ></v-checkbox>
        </div>
      </div>
      <div class="container-block">
        <div class="container-block-title">Этапы выборов</div>
        <v-tabs color="var(--app-dark-blue-1)">
          <v-tab v-for="(item, index) in stages" :key="index">{{ item }}</v-tab>

          <v-tab-item v-for="(i, index) in stages" :key="index">
            <div class="tab-inputs">
              <v-text-field
                label="Название"
                type="text"
                outlined
                :rules="rules"
                v-model="electionStages[index].name"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="Детализация"
                type="text"
                outlined
                :rules="rules"
                v-model="electionStages[index].detail"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                label="Сроки"
                type="text"
                outlined
                :rules="rules"
                v-model="electionStages[index].dates"
              ></v-text-field>
            </div>
            <ImageCropper
              @imageDesktopBlob="
                (img) => {
                  stagesPhoto[index].image = img;
                }
              "
              @imageMobileBlob="
                (img) => {
                  stagesPhoto[index].imageMobile = img;
                }
              "
              @imageTabletBlob="
                (img) => {
                  stagesPhoto[index].imageTablet = img;
                }
              "
              :width="'100%'"
              :modelValue="newImage"
              :imgSrcProp="electionStages[index].image"
              :imgSrcMobileProp="electionStages[index].imageMobile"
              :imgSrcTabletProp="electionStages[index].imageTablet"
              :placeToDisplay="'Отображается в разделе «Подробнее о выборах»'"
              hideTitle
            ></ImageCropper>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-form>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn
          @click="editElectionDetails"
          style="width: auto !important"
          class="button-accept"
        >
          Сохранить
        </v-btn>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
import ImageCropper from "@/components/inputs/ImageCropper.vue";

export default {
  components: {
    ImageCropper,
  },
  data: () => ({
    item: {},

    stages: ["Этап 1", "Этап 2", "Этап 3", "Этап 4", "Этап 5"],

    errImages: false,
    errImagesMain: false,
    dialogMobile: false,
    dialogTablet: false,
    isLoading: true,

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImage: null,
    imgSrcPagePhoto: "",
    imgSrcPageWrapper: "",

    mainPhoto: {
      desktop: "",
      mobile: "",
      tablet: "",
    },

    coverPhoto: {
      desktop: "",
      mobile: "",
      tablet: "",
    },

    stagesPhoto: [
      {
        image: "",
        imageMobile: "",
        imageTablet: "",
      },
      {
        image: "",
        imageMobile: "",
        imageTablet: "",
      },
      {
        image: "",
        imageMobile: "",
        imageTablet: "",
      },
      {
        image: "",
        imageMobile: "",
        imageTablet: "",
      },
      {
        image: "",
        imageMobile: "",
        imageTablet: "",
      },
    ],

    includedFile: undefined,

    resultImageMobile: "",
    resultImageTablet: "",

    finishImageMobile: "",
    finishImageTablet: "",

    electionStages: [],
    detailsBlock: {},

    imgSrc: "",

    smartphoneMainImage: null,
    tabletMainImage: null,
    formData: new FormData(),
  }),

  methods: {
    openFileSelection() {
      this.$refs.fileInput.$el.querySelector("input").click();
    },
    async editElectionDetails() {
      if (!this.$refs.formFirst.validate()) return;

      const imagesToAppend = [
        { key: "mainPhoto", file: this.mainPhoto.desktop },
        { key: "coverPhoto", file: this.coverPhoto.desktop },
        { key: "mainPhotoMobile", file: this.mainPhoto.mobile },
        { key: "coverPhotoMobile", file: this.coverPhoto.mobile },
        { key: "mainPhotoTablet", file: this.mainPhoto.tablet },
        { key: "coverPhotoTablet", file: this.coverPhoto.tablet },
      ];

      this.stagesPhoto.forEach((stage, index) => {
        imagesToAppend.push(
          { key: `stage-${index}Image`, file: stage.image },
          { key: `stage-${index}ImageMobile`, file: stage.imageMobile },
          { key: `stage-${index}ImageTablet`, file: stage.imageTablet }
        );
      });

      let hasError = false;
      imagesToAppend.forEach(({ key, file }) => {
        if (!file) {
          return;
        } else if (file instanceof File || file instanceof Blob) {
          this.formData.append(key, file);
        }
      });

      if (hasError) return;

      const uploadedImages = await this.uploadMultipleImages();
      const imagesObject = uploadedImages.reduce(
        (acc, { fieldname, ...rest }) => {
          acc[fieldname] = rest;
          return acc;
        },
        {}
      );

      try {
        const sendBody = {
          title: this.detailsBlock.title,
          subtitle: this.detailsBlock.subtitle,
          text: this.detailsBlock.text,
          image: imagesObject.mainPhoto?.url ?? this.detailsBlock.image,
          imageMobile:
            imagesObject.mainPhotoMobile?.url ?? this.detailsBlock.imageMobile,
          imageTablet:
            imagesObject.mainPhotoTablet?.url ?? this.detailsBlock.imageTablet,
          cover: imagesObject.coverPhoto?.url ?? this.detailsBlock.cover,
          coverMobile:
            imagesObject.coverPhotoMobile?.url ?? this.detailsBlock.coverMobile,
          coverTablet:
            imagesObject.coverPhotoTablet?.url ?? this.detailsBlock.coverTablet,
          url: this.detailsBlock.url ?? "",
          isWebView: this.detailsBlock.isWebView ?? false,
          stages: this.stagesPhoto.map((stage, index) => ({
            stage: index,
            name: this.electionStages[index].name,
            detail: this.electionStages[index].detail,
            dates: this.electionStages[index].dates,
            image:
              imagesObject[`stage-${index}Image`]?.url ??
              this.electionStages[index].image,
            imageMobile:
              imagesObject[`stage-${index}ImageMobile`]?.url ??
              this.electionStages[index].imageMobile,
            imageTablet:
              imagesObject[`stage-${index}ImageTablet`]?.url ??
              this.electionStages[index].imageTablet,
          })),
        };

        const res = await this.$axios.post(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-details",
          sendBody,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        );
        if (res.status === 201) {
          this.$store.commit("errorSet", {
            key: true,
            type: "success",
            text: "Данные обновлены",
          });
        }
      } catch (err) {
        this.$store.commit("errorSet", true);
        this.$store.commit("errorTextSet", err);
      }
    },

    back() {
      this.$emit("goToDetail");
    },

    async uploadMultipleImages() {
      const { data } = await this.$axios.post(
        this.$store.getters.apiAdminPanelV5 + "/upload/multiple",
        this.formData,
        {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        }
      );
      this.formData = new FormData();
      return data;
    },

    deleteIncludedFile() {
      this.includedFile = undefined;
    },

    getElectionDetails() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-details",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.electionStages = res.data.electionStages;
          this.electionStages = this.electionStages.concat(
            Array.from({ length: 5 - this.electionStages.length }, (_, i) => ({
              name: "",
              dateFrom: "",
              dateTo: "",
              detail: "",
              stage: i + this.electionStages.length,
              image: "",
              imageMobile: "",
              imageTablet: "",
            }))
          );
          this.detailsBlock = res.data.detailsBlock;
          this.includedFile = new File([res.data.detailsBlock.file], "file");

          this.isLoading = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    this.isLoading = true;
    this.getElectionDetails();
  },

  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 960px;
    margin-bottom: 20px;

    .tab-inputs {
      margin-top: 24px;
    }

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }
    .container-block-text {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: var(--app-dark-grey-1);
    }

    .pdf-preview {
      font-weight: 400;
      font-size: 18px;
      line-height: 100%;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }
  }

  .container-block::v-deep .v-slide-group__wrapper {
    padding-left: 0 !important;
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
